import React from 'react';
import { FaAward, FaUserGraduate, FaRocket, FaUsers, FaBook, FaStar } from 'react-icons/fa';

export default function WhySudeshMathsSection() {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-6">
                {/* Modern Header */}
                <div className="text-center mb-16">
                    <div className="inline-block mb-6">
                        <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-2xl px-6 py-3 shadow-sm">
                            <FaAward className="text-blue-600 text-lg" />
                            <span className="text-blue-700 font-semibold text-sm lemon-milk">EXCELLENCE IN EDUCATION</span>
                        </div>
                    </div>

                    <h2 className="text-4xl font-black text-gray-900 mb-4 lemon-milk">
                        Why Choose{' '}
                        <span className="text-blue-600">
                            Sudesh Maths?
                        </span>
                    </h2>

                    <p className="text-lg text-gray-600 max-w-2xl mx-auto poppins">
                        We're revolutionizing mathematics education with expert instruction,
                        proven methods, and a track record of student success.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-12 items-center">
                    {/* Image Side */}
                    <div className="relative">
                        <div className="absolute inset-0 bg-blue-600/20 rounded-2xl blur-xl transform -rotate-3"></div>
                        <div className="relative bg-white rounded-2xl p-3 shadow-xl">
                            <img
                                src="hero/4.jpg"
                                alt="Mathematics education excellence"
                                className="rounded-xl w-full h-auto"
                            />
                        </div>
                    </div>

                    {/* Features Side */}
                    <div className="space-y-6">
                        <div className="flex gap-4 p-6 bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg">
                                <FaUserGraduate className="text-white text-lg" />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-gray-900 mb-2 lemon-milk">Expert Mathematics Instructors</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">Learn from experienced mathematics educators with proven teaching methods and deep subject expertise.</p>
                            </div>
                        </div>

                        <div className="flex gap-4 p-6 bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex-shrink-0 w-12 h-12 bg-gray-600 rounded-lg flex items-center justify-center shadow-lg">
                                <FaRocket className="text-white text-lg" />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-gray-900 mb-2 lemon-milk">Practical Problem Solving</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">Master mathematics through hands-on problem solving and real-world applications that build confidence.</p>
                            </div>
                        </div>

                        <div className="flex gap-4 p-6 bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                            <div className="flex-shrink-0 w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center shadow-lg">
                                <FaAward className="text-white text-lg" />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-gray-900 mb-2 lemon-milk">Proven Results</h3>
                                <p className="text-gray-600 text-sm leading-relaxed poppins">Join hundreds of successful students who have achieved their academic goals with our proven teaching methods.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Achievement Stats */}
                <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div className="text-center">
                        <div className="w-16 h-16 bg-blue-600 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-lg">
                            <FaUsers className="text-white text-xl" />
                        </div>
                        <div className="text-2xl font-black text-blue-600 lemon-milk">500+</div>
                        <div className="text-sm text-gray-600 poppins">Students Taught</div>
                    </div>
                    <div className="text-center">
                        <div className="w-16 h-16 bg-gray-600 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-lg">
                            <FaAward className="text-white text-xl" />
                        </div>
                        <div className="text-2xl font-black text-gray-700 lemon-milk">95%</div>
                        <div className="text-sm text-gray-600 poppins">Pass Rate</div>
                    </div>
                    <div className="text-center">
                        <div className="w-16 h-16 bg-blue-500 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-lg">
                            <FaBook className="text-white text-xl" />
                        </div>
                        <div className="text-2xl font-black text-blue-600 lemon-milk">10+</div>
                        <div className="text-sm text-gray-600 poppins">Years Experience</div>
                    </div>
                    <div className="text-center">
                        <div className="w-16 h-16 bg-gray-500 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-lg">
                            <FaStar className="text-white text-xl" />
                        </div>
                        <div className="text-2xl font-black text-gray-700 lemon-milk">4.9</div>
                        <div className="text-sm text-gray-600 poppins">Rating</div>
                    </div>
                </div>
            </div>
        </section>
    );
}
